import { Injectable } from '@angular/core';
import { StorageConstants } from '../../constant/storage.constant';
import { AlertifyService } from '../core/alertify.service';
import { TranslateService } from '@ngx-translate/core';
import { OrderService } from './order.service';
import { PrinterService } from '../core/printer.service';
import { PrinterUtilsService } from '../printer/printer-utils.service';
import { PreviewHtmlModalComponent } from '../../pages/core/preview-html-modal/preview-html-modal.component';
import { ModalSizeEnum } from '../../enum/modal-size.enum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom } from 'rxjs';
import { OrderListHtmlRequest } from '../../models/rest/order/order-list-html-request';
import { ExportFileResponse } from '../../models/rest/common/export-file-response';
import { StringUtils } from '../../utils/string.utils';

@Injectable({
  providedIn: 'root'
})
export class OrderPrintUtilsService {

  constructor(
    private modalService: NgbModal,
    private alertifyService: AlertifyService,
    private translate: TranslateService,
    private orderService: OrderService,
    private printerService: PrinterService,
    private printerUtilsService: PrinterUtilsService) { }



  async printReceipt(orderId: number, printCount: number) {
    try {
      let printerName = await this.printerUtilsService.getPrinterName(StorageConstants.PRINTER_RECEIPT);

      const res = await this.orderService.getReceipt(orderId).toPromise();

      let request = this.printerService.convertPrinterSendRequest(res!);
      request.printerName = printerName;

      for (let i = 0; i < printCount; i++) {
        const resPrinter = await this.printerService.sendPrinter(request).toPromise();

        if (resPrinter!.statusCode == 'SUCCESS')
          this.alertifyService.success(this.translate.instant('message.info.receipt-is-printed'));
        else
          throw Error(request.printerName + " " + resPrinter!.statusExplanation);
      }
    }
    catch (err) {
      throw Error("Printer : " + err);
    }
  }
  async printExportFile(data: ExportFileResponse, printerNameKey: string) {
    try {
      let printCount: number = 1;
      let printerName = await this.printerUtilsService.getPrinterName(printerNameKey);
      let request = this.printerService.convertExportFilePrinterSendRequest(data);
      request.printerName = printerName;

      for (let i = 0; i < printCount; i++) {
        const resPrinter = await this.printerService.sendPrinter(request).toPromise();

        if (resPrinter!.statusCode == 'SUCCESS')
          this.alertifyService.success(this.translate.instant('message.info.receipt-is-printed'));
        else
          throw Error(request.printerName + " " + resPrinter!.statusExplanation);
      }
    }
    catch (err) {
      throw Error("Printer : " + err);
    }
  }


  async printOrderList(orderIds: number[]) {

    try {
      let printerName = await this.printerUtilsService.getPrinterName(StorageConstants.PRINTER_RECEIPT);

      let requestOrder = new OrderListHtmlRequest();
      requestOrder.orderIds = orderIds;

      const res = await firstValueFrom(this.orderService.getOrderListHtml(requestOrder));

      let request = this.printerService.convertPrinterSendRequest(res);
      request.printerName = printerName;

      const resPrinter = await this.printerService.sendPrinter(request).toPromise();

      if (resPrinter!.statusCode == 'SUCCESS')
        this.alertifyService.success(this.translate.instant('message.info.receipt-is-printed'));
      else
        throw Error(request.printerName + " " + resPrinter!.statusExplanation);
    }
    catch (err) {
      throw Error("Printer : " + err);
    }
  }

  async printAdditionalReceipt(orderId: number, printCount: number) {
    try {
      let printerName = await this.printerUtilsService.getPrinterName(StorageConstants.PRINTER_ADDITIONAL_RECEIPT);

      const res = await this.orderService.getAdditionalReceiptHtml(orderId).toPromise();

      let request = this.printerService.convertPrinterSendRequest(res!);
      request.printerName = printerName;

      for (let i = 0; i < printCount; i++) {
        const resPrinter = await this.printerService.sendPrinter(request).toPromise();

        if (resPrinter!.statusCode == 'SUCCESS')
          this.alertifyService.success(this.translate.instant('message.info.receipt-is-printed'));
        else
          throw Error(request.printerName + " " + resPrinter!.statusExplanation);
      }
    }
    catch (err) {
      throw Error("Printer : " + err);
    }
  }

  async printLabel(orderId: number) {
    try {
      let printerName = await this.printerUtilsService.getPrinterName(StorageConstants.PRINTER_LABEL);

      const res = await this.orderService.getLabel(orderId).toPromise();


      let request = this.printerService.convertPrinterSendRequest(res!);
      request.printerName = printerName;

      if (res!.dataList != null) {
        let counter = 0;

        for (let item of res!.dataList) {
          counter++;
          request.data = item;
          const resPrinter = await this.printerService.sendPrinter(request).toPromise();
          if (resPrinter!.statusCode == 'SUCCESS') {
            if (counter == 1)
              this.alertifyService.success(this.translate.instant('message.info.label-is-printed'));
          }
          else
            throw Error(request.printerName + " " + resPrinter!.statusExplanation);
        }
      }
      else if (StringUtils.isNotNull(res!.data) || StringUtils.isNotNull(res!.byteData)) {
        const resPrinter = await this.printerService.sendPrinter(request).toPromise();
        if (resPrinter!.statusCode == 'SUCCESS')
          this.alertifyService.success(this.translate.instant('message.info.label-is-printed'));
        else
          throw Error(request.printerName + " " + resPrinter!.statusExplanation);
      }
    }
    catch (err) {
      throw Error("Printer : " + err);
    }
  }

  async openCashDrawer() {
    try {

      let printerName = await this.printerUtilsService.getPrinterName(StorageConstants.PRINTER_RECEIPT);

      const res = await this.orderService.getOpenCashDrawer().toPromise();

      let request = this.printerService.convertPrinterSendRequest(res!);
      request.printerName = printerName;

      const resPrinter = await this.printerService.sendPrinter(request).toPromise();

      if (resPrinter!.statusCode == 'SUCCESS')
        this.alertifyService.success(this.translate.instant('message.info.cash-drawer-is-opened'));
      else
        throw Error(request.printerName + " " + resPrinter!.statusExplanation);

    }
    catch (err) {
      throw Error("Printer : " + err);
    }
  }


  async previewReceipt(orderId) {

    try {

      const res = await this.orderService.getReceiptHtml(orderId).toPromise();

      const modalRef = this.modalService.open(PreviewHtmlModalComponent, {
        backdrop: "static", centered: true, scrollable: true, size: ModalSizeEnum.MEDIUM
      });

      //modal  veri geçişi
      modalRef.componentInstance.data = res!.data;
      modalRef.componentInstance.fileName = res!.fileName;

      //modal cevap döndüğünde
      modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
        if (receivedEntry) {
        }

        // modal kapat
        modalRef.close();
      });
    }
    catch (err) {
      throw Error("Preview : " + err);
    }
  }
}
